//  <FileHeader xmlns="http://www.gordic.cz/shared/file-header/v_1.0.0.0">
//    <Name>        Gordic.Adm.WebControls.DetailAdeKnihaPLA.ts						</Name>
//    <Description> Dialog detailu srvspla - Kniha PLA										</Description>
//    <Author>      JKLUSACEK													</Author>
//    <Copyright>   � GORDIC spol. s r. o. 1993-2021                            </Copyright>
//    <Created>     2021-10-13                      </Created>
//  </FileHeader>

//This source code was auto-generated by ADT03-Generator, Version=486.16.5
//AdtGeneratorConfig:[ T:(srvspla) GID:(Web.Det.Ts) V1:(ixs_pla,rok,ico,nazev,zkratka,poznamka,aktivita,ktg_akce,dat_zmena,zmenu_prov,cpps_msk,ixp_den_old,priz_az_def,priz_gen_cis,ixs_csp,priz_ram_doh) V2:() K1:() K2:() K3:() ]

namespace Gordic.Adm.WebControls {

	const { gcontent } = Decorators;

    /** inteface - Response slu�eb pro Detail */
    export interface IDetailAdeKnihaPLAResponse {
        /** data v�stupu */
        data: Gordic.AdmIsl.Interface.GAdeKnihaPLAReadDto,

        result: {
            /** data v�stupu */
            data: Gordic.AdmIsl.Interface.GAdeKnihaPLAReadDto,
            /** chyby */
            errors: {
                /** zpr�va chyby */
                message: string
            }[],
            /** typ v�stupu operace */
            kind: Adm.Utils.GOperationResultKind
        }
    }

	//#endregion

	/** Dialog detailu  */
	@gcontent
    export class DetailAdeKnihaPLA extends GContentBase<DetailBase> {

		//#region attributes

        private gridRemoteControl: Gordic.Components.GridRC<any>;
        private gridCssClass: string;

            /** PK - ixs_pla */
        private ixs_pla: string | null;

        private rok: number | null;

        private ico: string | null;
        
        /** data detailu */
        private data: Gordic.AdmIsl.Interface.GAdeKnihaPLAReadDto;
		/** p��znak p��m�ho p��stupu na detail */
		private detailCommand: boolean
		/** Tab pro xxxx */
		//private strediskaTab: GStrediskaTab;

		//#endregion

		//#endregion


        /** onContentReady */
        public onContentReady() {
            this.init();
        }
		//#region ready & init

        public closing() {
            return DetailBase.CloseAction(this);
        }

        /** refreshDetail content */
        private refreshDetail(): void {
			this.load();
		}

        /** Na�ten� dat ze serveru na n�sledn� nastaven� na detail okn� */
        private loadData() {
            this.editMode = false;      // na��t�n� jde v�dy do ReadOnly m�du
            var fragments: string[] = [Utils.GAdmIslConst.detail];
            if (this.newRecord) 
                fragments.push(Utils.GAdmIslConst.defaultValuesForNewRecord);
            var readResult: any = this.isl.AdeKnihaPLA.read({
                data: { ixs_pla: this.ixs_pla, rok: this.rok, ico: this.ico },
                fragments: fragments
            } ).get();
            // SUCCESS
            readResult.done((output: IDetailAdeKnihaPLAResponse) => {
                if (output.result.kind === Utils.GOperationResultKind.Success) {
                    this.data = output.data;
                    this.sxsDetail = this.data.ixs_pla;
                    // p�evzet� dat do PK
                    this.ixs_pla = this.data.ixs_pla || null;
                    this.ico = this.data.ico || null;
                    this.rok = this.data.rok || null;
                    this.MetaData = this.data.MetaData || null;
                    this.Permissions = this.data.Permissions || null;
                    this.CreateStatusBar(this.data, this.newRecord);
                    this.createForm();
                    this.element.findFields().gfield("model", "apply", this.data);
                    if (this.newRecord) {
                        this.SetEditMode(true);       // p�i NEW je okno ihned p�epnuto do edit re�imu - mus� b�t p�ed setMenuButtons()
                        this.actions.actOpenInstitutPredpokladPlan?.update({ visible: false });
                        this.actions.actSeznamAdePovFunkcePlany?.update({ visible: false });
                        this.actions.actSeznamAdeSubradaCiselAkci?.update({ visible: false });
                        this.actions.actSeznamAdeProcesRealizaceKniha?.update({ visible: false });
                        this.actions.actSeznamAdmVlastnostObecnyObjekt?.update({ visible: false });
                    }
                    this.SetMenuButtons(this.editMode);
                    this.createSidebar();
                } else {
                    var errors = output.result.errors;
                    for (var index = 0; index < errors.length; index++) {
                        var error = errors[index];
                        this.ShowErrorNot({ text: error.message, title: "jres:33000146" });
                    }
                }
            });
            // ERROR
            readResult.fail((err) => {
                console.error("Chyba na�ten�! " + err);
                if (err.responseJSON) {
                    if (err.responseJSON.exception.containsNonFatal != true)
                        this.ShowErrorNot({ text: "jres:32131045!", title: "jres:33000146" })
                }
            });   
        } // loadData

        private updateGrid( dto: Gordic.AdmIsl.Interface.GAdeKnihaPLAReadDto ): any {
            return this.isl.AdeKnihaPLA.list({
              filters: { ixs_pla: dto.ixs_pla },
            }).getView()
        }

		//#endregion

        /** Ulo�en� dat formul��e do datab�ze */
        private saveData(nova_data: Gordic.AdmIsl.Interface.GAdeKnihaPLASaveDto): void {
            var upsertResult: any = this.isl.AdeKnihaPLA.upsert({ data: nova_data }).get();
            upsertResult.done((output: IDetailAdeKnihaPLAResponse) => {
                if (output.result.kind === Utils.GOperationResultKind.Success) {
                    Gordic.Data.readerCache.clearCache("Gordic.ControlsLogic.Client.GReaderSrvspla");
                    this.refreshGrid(output.data, this.newRecord);
                    this.newRecord = false;
                    this.data = output.data; // prevezmu nova data vznikla ulozenim
                    this.sxsDetail = this.data.ixs_pla;
                    // p�evzet� dat do PK
                    this.ixs_pla = this.data.ixs_pla || null;
                    this.rok = this.data.rok || null;
                    this.ico = this.data.ico || null;
                    this.MetaData = this.data.MetaData || null;
                    this.Permissions = this.data.Permissions || null;
                    this.CreateStatusBar(this.data, this.newRecord);
                    this.createForm();                // znovu vytvo��m� cel� form 
                    this.element.findFields().gfield("model", "apply", this.data);  // nasetov�n�� nov�ch dat do detailu
                    this.SetEditMode(false);
                    this.actions.actOpenInstitutPredpokladPlan?.update({ visible: true });
                    this.actions.actSeznamAdePovFunkcePlany?.update({ visible: true });
                    this.actions.actSeznamAdeSubradaCiselAkci?.update({ visible: true });
                    this.actions.actSeznamAdeProcesRealizaceKniha?.update({ visible: true });
                    this.actions.actSeznamAdmVlastnostObecnyObjekt?.update({ visible: true });
                    this.SetMenuButtons(false);
                    this.ShowSucessNot({ title: "jres:33000146", text: "jres:32000123" })
                    this.createSidebar();
                }
                else {
                    var errors = output.result.errors;
                    for (var index = 0; index < errors.length; index++) {
                        var error = errors[index];
                        this.ShowErrorNot({ title: "jres:33000146", text: error.message })
                    }
                }

            });
            upsertResult.fail((err) => {
                console.error("Chyba ulo�en�! ");
                if (err.responseJSON.exception.containsNonFatal != true)
                    this.ShowErrorNot({ text: "jres:32000125!", title: "jres:33000146", exception: err.responseJSON.exception })
            });            
        }

        private refreshGrid(output: Gordic.AdmIsl.Interface.GAdeKnihaPLAReadDto, newRecord: boolean) {
            var gridElement = this.gridRemoteControl as any;
            var grid = gridElement.gridInstance.element;
            if (grid.length != 0) {
                this.updateGrid(output).done((d: Gordic.Data.View) => {
                   var data = d.getDataRows(true, "data")[0];
                   var view: Gordic.Data.View = grid.ggrid("getView");
                   if (this.newRecord == true)
                      view.updateData(data, "add");
                   else
                      view.updateData(data, "update");
                   grid.ggrid("setData", view);
               });
            }
        }

		/** init content */
		private init() {
			DetailBase.DetailBaseInit(this);
			this.formElement = null;
			// lezu na detail ze seznamu a ne pomoc� linku
			if (this.detailCommand === false) {
				var GinListControlsObject = (Gin.DetailBuilderComponents as any).GinListControls.create(this);
				this.actions.addRange(GinListControlsObject.actions);
				this.createStatusBar(GinListControlsObject.statusBar);
				$.extend(this, GinListControlsObject.contentExtensions);
			}
			this.setTitle();
			this.createMenuBar();
			this.loadData();            // to soucasne vytvori form podle nactenych dat; 
            // lezu na detail ze seznamu a ne pomoc� linku
			if (this.detailCommand === false) {
				// vytvo�it �ipky na proch�zen� detailu
                (this as any).listControls_setup({
                    //gridRemoteControl: this.gridRemoteControl,
					//funkce, kter� ��dek z gridu p�etransformuje v dto pro zavol�n� this.load(dto); M��e vracet promise.
					rowToDto: function (gridState) {
						return {
                            ixs_pla: gridState.currentRow.data.ixs_pla,
						};
					},
					//template pro tooltip na �ipce n�sleduj�c�
                    nextItemTemplate: "jres:33000155",
					//template pro tooltip na �ipce p�edchoz�
                    prevItemTemplate: "jres:33000156" //RC 33000156 : jres:33000156
				});
				(this as any).listControls_updateCaptions();
            }
		}

		/** vytvo�it statusbar */
		private createStatusBar(GinListControlsObject?: any) {
			const bar: MenuParams[] = [];
			if (GinListControlsObject !== undefined) {
				bar.push.apply(bar, GinListControlsObject);
			}
			this.statusBar(bar);
		}

		//#endregion

		//#region data

		//#region title

		/** nastavit titulek dialogu */
		private setTitle() {
            var title = "";
            if (this.newRecord === false) 
                title = "jres:32131033"  	//RC 32131033 : Detail
            else 
                title = "jres:32000121" //RC 32000121 : Nov� z�znam
            this.title = title;
		}


		//#endregion

		//#region form

		/** vytvo�it formul�� a na�ten� dat ze serveru */
        private createForm() {
            var nemenne = "jres:32131150"; //RC 32131150 : Nem�nn�
            this.MakeForm("FormAdeKnihaPLAService");
            this.MakeSection("jres:33000146"); //RC 33000146 : Kniha
            this.MakeField("ixs_pla" );
            this.MakeField("rok");
            this.MakeSelectField("ico", Gordic.Prefabs.Select.ekosico(), { model: "model.ico=value.ico" });
            this.MakeField("nazev"); 
            this.MakeField("zkratka");
            this.MakeSelectField("ktg_akce", Gordic.Prefabs.Select.srvckta(), { model: "model.ktg_akce=value.ktg_akce" });
            this.MakeField("poznamka");
            this.MakeSelectField("priz_az_def", Gordic.Prefabs.Select.gincpan(), { model: "model.priz_az_def=value.priz_an" });
            this.MakeSelectField("ixs_csp", Gordic.Prefabs.Select.srvscsp(), { model: "model.ixs_csp=value.ixs_csp" })
            this.MakeSelectField("ixs_prr_def", Gordic.Prefabs.Select.admSrvsprr(), {
                model: "model.ixs_prr_def=value.ixs_prr",
                serverFilters: {
                    rok: new Gordic.Forms.Dependency("rok", (value) => { return value }, true, false, this.element),
                    ixs_pla: new Gordic.Forms.Dependency("ixs_pla", (value) => { return value }, true, false, this.element)
                }
            })
            this.MakeSelectField("ixs_sro_az", Gordic.Prefabs.Select.wflssro(), {
                model: "model.ixs_sro_az=value.ixs_sro",
                validators: [ Gordic.Adm.WebControls.GAdmUtilsValidators.SpecialValidatorSchvalovaciRole() ],
                serverFilters: {
                    ktg_sch_role: 180,  // �prava pro administraci ADA05
                    aktivita: 100
                }
            })
            this.MakeSelectField("ixs_tri_def", Gordic.Prefabs.Select.admSrvstri(), {
                model: "model.ixs_tri_def=value.ixs_tri",
                serverFilters: {
                    aktivita: 100
                }
            })
            this.MakeSelectField("aktivita", Gordic.Prefabs.Select.gincakt());
            if (this.newRecord == false)
                this.MakeSection("jres:33000087") //RC 33000087 : Auditn� z�znamy
            this.MakeField("dat_zmena"); 
            this.MakeSelectField("zmenu_prov", Gordic.Prefabs.Select.ginszmp(), { model: "model.zmenu_prov=value.ixs_zmp" });
            var form = this.FinishMakeForm();

		}

		//#endregion

		//#region menubar

		private nextAndPreviousAction(next: boolean) {
		    var obj: any;
		    if (next == true)
		        obj = this.gridRemoteControl.current().nextRow.data;
		    else
		        obj = this.gridRemoteControl.current().prevRow.data;
		    this.gridRemoteControl.move(next);
		    var gridElement = this.gridRemoteControl as any;
		    Dialogs.DetailAdeKnihaPLADlg($.content(gridElement.gridInstance.element), { ixs_pla: obj.ixs_pla, rok: obj.rok, ico: obj.ico, grid:gridElement.gridInstance.element, newRecord: false })
		this.close();
		}

		/** vytvo�it menubar */
        private createMenuBar() {

            const menuBar: MenuParams[] = [];

            this.actions.addRange({
                actNext: {
                    caption: "jres:33000001",  //RC 33000001 : Dal���
                    captionVisible: "never",
                    icon: "gi-arrow-down",
                    run: (ev, ctx) => {
                        this.nextAndPreviousAction(true);
                    }
                },
                actPrevious: {
                    caption: "jres:33000002", //RC 33000002 : P�edchoz�
                    captionVisible: "never",
                    icon: "gi-arrow-down gi-rot180",
                    run: (ev, ctx) => {
                        this.nextAndPreviousAction(false);
                    }
                },
                actSaveRecord: {
                    visible: this.newRecord,
                    icon: "gi-save",
                    caption: "jres:32131041",			//RC 32131041 : Ulo�it
                    run: () => {
                        // kolekce dat
                        var nova_data: Gordic.AdmIsl.Interface.GAdeKnihaPLASaveDto = {};       // vytvo��m pr�zdn� objekt spr�vn�ho typu
                        var form = this.findForms("FormAdeKnihaPLAService")
                        if (form.gform("isValid")) {
                            this.findFields().gfield("model", "collect", nova_data);    // na�tu do n�j data z formul��e
                            this.saveData(nova_data);                                   // pokus�m se ulo�it data do DB
                        }
                    }
                },
                actEditRecord: {
                    visible: true,
                    icon: "gi-pencil",
                    caption: "jres:32000120",			//RC 32000120 : Editace
                    run: () => {
                        this.SetEditMode(true);
                        this.actions.actOpenInstitutPredpokladPlan?.update({ visible: false });
                        this.actions.actSeznamAdePovFunkcePlany?.update({ visible: false });
                        this.actions.actSeznamAdeSubradaCiselAkci?.update({ visible: false });
                        this.actions.actSeznamAdeProcesRealizaceKniha?.update({ visible: false });
                        this.actions.actSeznamAdmVlastnostObecnyObjekt?.update({ visible: false });
                        this.SetMenuButtons(true);
                    }
                },
                actCancelSaveRecord: {
                    visible: false,
                    icon: "gi-window-close",
                    caption: "jres:32000122",			//RC 32000122 : Ukon�it editaci
                    run: () => {
                        this.refreshDetail();           // ob�erstv�m p�vodn� data z datab�ze
                        this.SetEditMode(false);
                        this.actions.actOpenInstitutPredpokladPlan?.update({ visible: true });
                        this.actions.actSeznamAdePovFunkcePlany?.update({ visible: true });
                        this.actions.actSeznamAdeSubradaCiselAkci?.update({ visible: true });
                        this.actions.actSeznamAdeProcesRealizaceKniha?.update({ visible: true });
                        this.actions.actSeznamAdmVlastnostObecnyObjekt?.update({ visible: true });
                        this.SetMenuButtons(false);
                    }
                },
                actRefresh: {
                    icon: "gi-refresh",
                    caption: "jres:32131040",			//RC 32131040 : Ob�erstven�
                    run: () => {
                        this.refreshDetail();
                    }
                },
                actOpenInstitutPredpokladPlan: {
                    icon: "fa-link",
                    caption: "jres:29807982",
                    run: () => {
                        this.openSeznamAdeInstitutPredpokladPlan();
                    }
                },
                actSeznamAdePovFunkcePlany: {
                    icon: "fa-link",
                    caption: "jres:29807981",
                    run: () => {
                        this.openSeznamAdePovFunkcePlany();
                    }
                },
                actSeznamAdeSubradaCiselAkci: {
                    icon: "fa-link",
                    caption: "jres:29807911",
                    run: () => {
                        this.openSeznamAdeSubradaCiselAkci();
                    }
                },
                actSeznamAdeProcesRealizaceKniha: {
                    icon: "fa-link",
                    caption: "jres:33000166", //RC 33000166 : Procesy realizace na knize
                    run: () => {
                        this.openSeznamAdeProcesRealizaceKniha()
                    }
                },
                actSeznamAdmVlastnostObecnyObjekt: {
                    icon: "fa-expand",
                    caption: "jres:33000420", //RC 33000412 : Nav�zan� vlastnosti
                    run: () => {
                        this.openSeznamAdmVlastnostObecnyObjekt()
                    }
                },
                actZavrit: {
                    icon: "gi-window-close",
                    caption: "jres:32131042",				//RC 32131042 : Zav��t
                    run: () => {
                        this.closing().done(() => { this.close() });
                    }
                }
            });

            this.menuBar([
                { action: this.actions.actSaveRecord, favorite: true },
                { action: this.actions.actEditRecord, favorite: true },
                { action: this.actions.actCancelSaveRecord, favorite: true, visible: !this.newRecord },
                { action: this.actions.actRefresh, favorite: true, visible: !this.editMode },
                { action: this.actions.actOpenInstitutPredpokladPlan, favorite: true, visible: !this.editMode },
                { action: this.actions.actSeznamAdePovFunkcePlany, favorite: true, visible: !this.editMode },
                { action: this.actions.actSeznamAdeSubradaCiselAkci, favorite: true, visible: !this.editMode },
                { action: this.actions.actSeznamAdeProcesRealizaceKniha, favorite: true, visible: !this.editMode },
                { action: this.actions.actSeznamAdmVlastnostObecnyObjekt, favorite: true, visible: !this.editMode },
                { action: this.actions.actPrevious, favorite: true, align: "opposite", visible: !this.newRecord },
                { action: this.actions.actNext, favorite: true, align: "opposite", visible: !this.newRecord },
            ])
            this.actions.actPrevious?.enabled(this.gridRemoteControl.current()?.prevRow != null);
            this.actions.actNext?.enabled(this.gridRemoteControl.current()?.nextRow != null);
            this.commandBar(this.actions.createBar(["actZavrit*"]));
        }

		//#endregion

		//#region sidebar

		/** vytvo�it panel */
		private createPanel(): GSideBarPanelOptions {

			this.panelId = "panelNahled";

			let panel = {
				minWidth: 300,
				id: this.panelId,
				caption: "jres:32131038",							//RC 32131038 : N�hled
                leaf: "jres:32131038",								//RC 32131038 : N�hled
                icon: "gi-nahled",
				open: (ev, obj) => {
					this.refreshPanel(ITypePanel.Neurceno, $(ev.target))
				},
			} as GSideBarPanelOptions;

			return panel;
		}

		/** odstranit sidebar */
		private removeSidebar() {
			if (this.sidebar !== undefined) {
				this.sidebar.gsidebar("removeAll");
			}
		}

		/** vytvo�it sidebar */
		private createSidebar() {

			this.removeSidebar();
			var myPanels: GSideBarBarOptions[] = [];

			var auditPristupu = new Gordic.Adm.WebControls.AdmAuditPristupu();
			var panelAudit = auditPristupu.create( this.sxsDetail || "", this.MetaData?.typ_obj || 0);
			myPanels.push(panelAudit);

			//var extIdentifikace = new Gordic.Adm.WebControls.AdmExtIdentifikace();
			//var panelExtIdentifikace = extIdentifikace.create( this.sxsDetail || "", this.MetaData?.typ_obj || 0);
			//myPanels.push(panelExtIdentifikace);

			//var poznamky = new Gordic.Adm.WebControls.AdmPoznamky();
			//var panelPoznamky = poznamky.create(this,  this.sxsDetail || "", this.MetaData?.typ_obj || 0);
			//myPanels.push(panelPoznamky);

			this.sidebar = $(this.element).gsidebar({
				userSettings: this.userSettings,
				right: {
					pinned: true,
					panels: myPanels
				}
			});
		}

		/** ob�erstven� panelu v sidebaru */
		private refreshPanel(type: ITypePanel, elementPanel?: JQuery<HTMLElement>): void {

			var panel: JQuery<HTMLElement> | undefined;

			if (this.sidebar !== undefined) {
				panel = this.sidebar.gsidebar("getPanel", this.panelId);
			}
			else {
				panel = elementPanel;
			}

			if (panel !== undefined) {

				if (this.panelElement !== undefined) {
					this.panelElement.remove();
				}

				this.panelElement = $("<div>").appendTo(panel);

				//if (type === ITypePanel.HistorieSpusteni) {
				//	GridUtils.setPanelGrid("jres:32000055", this.row_historie_spusteni, this.gridFormatHistorieSpusteni, this.panelElement);
				//}
				//else {
					this.setPreviewEmpty();
				//}

			}

		}
        /** vytov�en� pr�zdn�ho sidebar panelu s n�hledek */
		private setPreviewEmpty(): void {
			var p7s_element = $("<div'>").addClass("Adm-p7s-class");
			p7s_element.appendTo(this.panelElement);
			p7s_element.text("jres:32131043"); //RC 32131043 : N�hled nen� k dispozici.
		}

		//#endregion

        private openSeznamAdeInstitutPredpokladPlan() {
            this.navigate(["Gordic.Adm.WebControls.SeznamAdeInstitutPredpokladPlan"], { Id: "SeznamAdeInstitutPredpokladPlan", ixs_pla: this.data.ixs_pla });
        }

        private openSeznamAdePovFunkcePlany() {
            this.navigate(["Gordic.Adm.WebControls.SeznamAdePovFunkcePlany"], { Id: "SeznamAdePovFunkcePlany", ixp_den: this.data.ixs_pla })
        }

        private openSeznamAdeSubradaCiselAkci() {
            this.navigate(["Gordic.Adm.WebControls.SeznamAdeSubradaCiselAkci"], { Id: "SeznamAdeSubradaCiselAkci", ixs_pla: this.data.ixs_pla, rok: this.data.rok, ico: this.data.ico })
        }

        private openSeznamAdeProcesRealizaceKniha() {
            this.navigate(["Gordic.Adm.WebControls.SeznamAdeProcesRealizaceKniha"], { Id: "SeznamAdeProcesRealizaceKniha", ixs_pla: this.data.ixs_pla })
        }

        private openSeznamAdmVlastnostObecnyObjekt() {
            this.navigate(["Gordic.Adm.WebControls.SeznamAdmVlastnostObecnyObjekt"], { Id: "SeznamAdmVlastnostObecnyObjekt", typ_obj: this.data.MetaData?.typ_obj, sxs: this.sxsDetail, ico: this.data.ico, nazev: "{0} - {1}".format(this.data.rok?.toString(), this.data.nazev?.toString()) })
        }
	}
}
